// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21","list_container":"Categories__list_container___24-Bt","recent_cars":"Categories__recent_cars___-K5GU","icon_container":"Categories__icon_container___141v7","recent_car_container":"Categories__recent_car_container___LqIK4","responsive_img":"Categories__responsive_img___zXXwj","car_info":"Categories__car_info___3MqpH","car_year":"Categories__car_year___yZKnb"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Catalog/Categories.scss
 ** module id = 1343
 ** module chunks = 0
 **/